import { useEffect } from 'react';
import { isAdminApp } from '~/public/lib/PageHelpers.js';
import { formatCurrency } from '~/lib/CurrencyHelpers.js';

const PaymentQuestion = ({ value, setValue, settings, label }) => {
    const amount = settings?.amount;

    useEffect(() => {
        // Just set payment value
        setValue({
            addons: [
                {
                    addon: {
                        name: label,
                        price: amount,
                    },
                    quantity: 1,
                },
            ],
            oncePerTransaction: true,
            //price: amount,
        });
    }, []);

    if (isAdminApp()) {
        return (
            <div className="text-gray-500">
                Clients will be required to pay {formatCurrency(amount || 0)} to
                submit this form.
                <div className="mt-2">
                    This is in addition to the cost of any appointments,
                    packages, or add-ons they are selecting in this form.
                </div>
            </div>
        );
    } else {
        return null;
    }
};

export default PaymentQuestion;
